var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_67_8900)","key":0},React.createElement("path",{"d":"M9.50017 1.5V5.5L7.09974 5.50002C0.301901 5.50002 0.70186 12.1875 0.70186 13C1.36832 11.9167 2.30126 10.5 5.50024 10.5L9.50017 10.5V14.5L15.0002 7.50002L9.50017 1.5Z","stroke":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_67_8900"},React.createElement("rect",{"width":"16","height":"16","fill":"currentColor"})))]);
}

Share.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Share;

Share.default = Share;
